import axiosNest from '@/shared/api/instance/axiosNest';

// 파트너사 대시보드 조회
export const getPartnerDashboardAPI = async () => {
  const response = await axiosNest.get('/partner-admin/dashboard');
  return response.data.data;
};

// 파트너사 메뉴 조회
export const getPartnerMenuAPI = async () => {
  const response = await axiosNest.get('/partner-admin/menu');
  return response.data.data;
};

// 파트너사 상품 조회 (MongoDB 캐시)
export const getPartnerProductsAPI = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  const response = await axiosNest.get('/partner-admin/products', { params });
  return response.data.data;
};

// 파트너사 상품 조회 (실시간)
export const getPartnerProductsLiveAPI = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const response = await axiosNest.get('/partner-admin/products/live', {
    params,
  });
  return response.data.data;
};

// 파트너사 정산 조회 (실시간)
export const getPartnerSettlementsLiveAPI = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const response = await axiosNest.get('/partner-admin/settlements/live', {
    params,
  });
  return response.data.data;
};

// 파트너사 주문 조회 (실시간)
export const getPartnerOrdersLiveAPI = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const response = await axiosNest.get('/partner-admin/orders/live', {
    params,
  });
  return response.data.data;
};

// 파트너사 정산 요약 조회
export const getPartnerSettlementSummaryAPI = async (params?: {
  year?: number;
  month?: number;
}) => {
  const response = await axiosNest.get('/partner-admin/settlement/summary', {
    params,
  });
  return response.data.data;
};

// 파트너사 정산 상세 조회
export const getPartnerSettlementDetailsAPI = async (params?: {
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await axiosNest.get('/partner-admin/settlement/details', {
    params,
  });
  return response.data.data;
};
